import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { LivePagesByLinePlaceholderComponent } from './LivePagesByLinePlaceholderComponent';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EICByLinePlaceholder = styled.div({
	height: `${token('space.400')}`,
});

export const EditorByLinePlaceholder = ({ isLivePage }) => {
	if (isLivePage) {
		return <LivePagesByLinePlaceholderComponent />;
	} else {
		return (
			<EICByLinePlaceholder data-testid="editor-in-context-by-line-placeholder">
				&nbsp;
			</EICByLinePlaceholder>
		);
	}
};
